import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(6, 3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: theme.spacing(3, 3), // 24px vertical on mobile
    },
  },

  footerStack: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      gap: 24, // 24px vertical spacing on mobile
    },
  },
  footerContentTop: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 24, // 24px on mobile
    },
  },
  logoAndLinksContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    gap: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      gap: 24, // 24px on mobile
    },
  },
  /** Box sizes the slot; `Image` uses `fill` so SSR/client match (no `useMediaQuery` on the img). */
  logoWrapper: {
    position: 'relative',
    flexShrink: 0,
    width: 113,
    height: 34,
    [theme.breakpoints.down('md')]: {
      height: 28,
    },
  },
  logoImage: {
    objectFit: 'contain',
    opacity: 0.7,
  },
  topLinksContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'center',
      gap: theme.spacing(3),
    },
  },
  footerLinkInline: {
    color: theme.palette.common.white,
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(14.5),
    fontWeight: 700,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  socialMediaContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'center',
    },
  },
  socialMediaIcon: {
    fontSize: theme.typography.pxToRem(35),
    color: theme.palette.custom.grey.main, // Always #C8C8C8 in both modes
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(25),
    },
  },

  divider: {
    backgroundColor: theme.palette.custom.grey.dark, // Always #333333 in both modes
    borderColor: 'rgba(255, 255, 255, 0.12)', // Static border color - same in both modes
    height: theme.typography.pxToRem(1.5),
    margin: 0,
  },

  footerLink2: {
    color: 'rgba(255, 255, 255, 0.6)', // keep consistent light/dark appearance
    textDecoration: 'none',
    fontSize: theme.typography.pxToRem(14),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  footerBottom: {
    width: '100%',
  },
  botLinksContainer: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'center',
    },
  },
}));
